import { type ReactNode, forwardRef } from 'react';

type Props = {
    title: string;
    children?: ReactNode;
}

export const SectionTitle = forwardRef(({ title, children }: Props, ref: React.Ref<HTMLDivElement>) => {
    return (
        <div className="flex flex-col flex-1 gap-2" ref={ref}>
            <div className="flex justify-between">
                <div>
                    <p className="text-xs">{title}</p>
                </div>

                {children && (
                    <div className="flex items-center justify-center gap-1">
                        {children}
                    </div>
                )}
            </div>
        </div>
    )
})
